import React from 'react';
import Svg, { Mask, Path, Rect, ClipPath, G, Defs } from 'react-native-svg';

export function HomeFilled({ width, height }) {
  return (
    <>
      <Svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 21 21"
        fill="none"
      >
        <Path
          d="M1.24112 1.49112C1.47554 1.2567 1.79348 1.125 2.125 1.125H15.875C16.2065 1.125 16.5245 1.2567 16.7589 1.49112C16.9933 1.72554 17.125 2.04348 17.125 2.375V6.125C17.125 6.45652 16.9933 6.77446 16.7589 7.00888C16.5245 7.2433 16.2065 7.375 15.875 7.375H2.125C1.79348 7.375 1.47554 7.2433 1.24112 7.00888C1.0067 6.77446 0.875 6.45652 0.875 6.125V2.375C0.875 2.04348 1.0067 1.72554 1.24112 1.49112ZM1.24112 11.4911C1.47554 11.2567 1.79348 11.125 2.125 11.125H5.875C6.20652 11.125 6.52446 11.2567 6.75888 11.4911C6.9933 11.7255 7.125 12.0435 7.125 12.375V13.625C7.125 13.9565 6.9933 14.2745 6.75888 14.5089C6.52446 14.7433 6.20652 14.875 5.875 14.875H2.125C1.79348 14.875 1.47554 14.7433 1.24112 14.5089C1.0067 14.2745 0.875 13.9565 0.875 13.625V12.375C0.875 12.0435 1.0067 11.7255 1.24112 11.4911ZM11.2411 11.4911C11.4755 11.2567 11.7935 11.125 12.125 11.125H15.875C16.2065 11.125 16.5245 11.2567 16.7589 11.4911C16.9933 11.7255 17.125 12.0435 17.125 12.375V13.625C17.125 13.9565 16.9933 14.2745 16.7589 14.5089C16.5245 14.7433 16.2065 14.875 15.875 14.875H12.125C11.7935 14.875 11.4755 14.7433 11.2411 14.5089C11.0067 14.2745 10.875 13.9565 10.875 13.625V12.375C10.875 12.0435 11.0067 11.7255 11.2411 11.4911Z"
          fill="#368665"
        />
      </Svg>
    </>
  );
}
